import { Instagram, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { useApp } from "../context/AppContext";
import { ADDRESS, EMAIL, EXTRA_PHONES, INSTAGRAM_URL, MAPS_URL, WA_DISPLAY } from "../lib/site";
import { scrollToId } from "../lib/site";
import { Reveal } from "./Reveal";

export const Footer = () => {
  const { t, waLink, lang } = useApp();
  return (
    <footer className="bg-[#0C0B0B] text-neutral-200" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 pb-12 pt-24 md:px-10 md:pt-32">
        <Reveal>
          <a href={waLink} target="_blank" rel="noopener noreferrer" data-testid="footer-big-cta" className="group block">
            <h2 className="font-display text-[13vw] font-bold leading-[0.95] tracking-tighter text-neutral-100 transition-colors duration-300 group-hover:text-primary md:text-[9vw]">
              {t.footer.big}
            </h2>
            <p className="mt-4 max-w-md text-neutral-400">{t.footer.sub}</p>
          </a>
        </Reveal>

        <div className="mt-20 grid gap-12 border-t border-white/10 pt-12 md:grid-cols-3">
          <div>
            <div className="inline-flex items-center rounded-xl bg-white px-3 py-2">
              <img src="/logo.png" alt="PT. Natama Trans Asia — Comfort in Journey" className="h-9 w-auto" />
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-neutral-400">{t.tagline} — PT. Natama Trans Asia.</p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-neutral-500">{t.footer.explore}</p>
            <ul className="mt-5 space-y-3">
              {t.nav.map((item) => (
                <li key={item.id}>
                  <button
                    data-testid={`footer-nav-${item.id}`}
                    onClick={() => scrollToId(item.id)}
                    className="text-sm font-medium text-neutral-300 transition-colors duration-200 hover:text-primary"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-neutral-500">{t.footer.contact}</p>
            <ul className="mt-5 space-y-4">
              <li>
                <a href={waLink} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-sm font-medium text-neutral-300 transition-colors duration-200 hover:text-primary">
                  <MessageCircle className="h-4 w-4" /> {WA_DISPLAY}
                </a>
              </li>
              {EXTRA_PHONES.map((p) => (
                <li key={p.key}>
                  <a
                    href={`https://wa.me/${p.number}?text=${encodeURIComponent(t.waMessage)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-phone-${p.key}`}
                    className="flex items-center gap-3 text-sm font-medium text-neutral-300 transition-colors duration-200 hover:text-primary"
                  >
                    <Phone className="h-4 w-4" /> {p.display}
                    <span className="text-xs text-neutral-500">({p.role[lang]})</span>
                  </a>
                </li>
              ))}
              <li>
                <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="flex items-center gap-3 text-sm font-medium text-neutral-300 transition-colors duration-200 hover:text-primary">
                  <Mail className="h-4 w-4" /> {EMAIL}
                </a>
              </li>
              <li>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 text-sm font-medium text-neutral-300 transition-colors duration-200 hover:text-primary">
                  <Instagram className="h-4 w-4" /> natama_transasia
                </a>
              </li>
              <li>
                <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-address" className="flex items-start gap-3 text-sm font-medium text-neutral-300 transition-colors duration-200 hover:text-primary">
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0" /> {ADDRESS}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-8 text-xs text-neutral-500 md:flex-row md:items-center">
          <p>{t.footer.rights}</p>
          <p className="uppercase tracking-[0.2em]">Big Bus · Medium Bus · Hiace</p>
        </div>
      </div>
    </footer>
  );
};
